import capitalize from "@material-ui/core/utils/capitalize";
import i18next from "i18next";
import { withBreadCrumbs } from "lego-gui-lib";
import { IFrame } from "lego-gui-lib/lib";
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, RouteComponentProps, Switch } from "react-router";

export const Dashboard = {
  url: "/dashboard",
  handler: (props: RouteComponentProps<any>) => {
    const title = capitalize(i18next.t("common:dashboard"));
    const baseUrl = props.match.url;
    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <Switch>
        <Route exact={true} path={baseUrl} component={ShowIframe} />
      </Switch>
    );
  }
};

export const ShowIframe = () => {
  const i18n = useTranslation();
  const title = capitalize(i18n.t("common:dashboard"));
  return (
    <IFrame
      title={title}
      link={
        "http://192.168.1.55:5601/app/kibana#/dashboard/87dc5de0-8f4d-11e8-9387-55d123aebd26?embed=true&_g=(refreshInterval%3A(display%3AOff%2Cpause%3A!f%2Cvalue%3A0)%2Ctime%3A(from%3A'Tue%20Feb%2019%202019%2000%3A00%3A00%20GMT%2B0100'%2Cmode%3Aabsolute%2Cto%3A'Tue%20Feb%2019%202019%2023%3A59%3A59%20GMT%2B0100'))"
      }
    />
  );
};
